import type { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { BarChart3, LogOut, Users } from "lucide-react";
import { api } from "../lib/api";
import { useMe } from "../App";

export function AppHeader({ right, extra }: { right?: ReactNode; extra?: ReactNode }) {
  const { data: me } = useMe();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const logout = useMutation({
    mutationFn: () => api.post("/api/auth/logout"),
    onSettled: () => {
      queryClient.clear();
      navigate("/login", { replace: true });
    },
  });

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-4">
        <div className="flex min-w-0 items-center gap-2">
          <Link to="/" className="flex items-center gap-2 text-sm font-semibold text-slate-800">
            <span className="flex size-7 shrink-0 items-center justify-center rounded-lg bg-emerald-600 text-white">
              <BarChart3 size={16} />
            </span>
            Statistik
          </Link>
          {extra}
        </div>
        <div className="flex items-center gap-3">
          {right}
          {me && <span className="hidden text-xs text-slate-500 sm:inline">{me.username ?? me.email}</span>}
          {me && (
            <Link to="/users" className="btn px-2" title="Pengguna">
              <Users size={15} />
            </Link>
          )}
          {me && (
            <button
              type="button"
              onClick={() => logout.mutate()}
              className="btn px-2"
              title="Keluar"
              disabled={logout.isPending}
            >
              <LogOut size={15} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
